module.exports = __webpack_public_path__ + "static/media/Education.ce010af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Education.png
// module id = 1707
// module chunks = 0 1